/** Radix dropdown / menu surfaces (account/org switchers in navbar and enterprise sidebar). */
const RADIX_DROPDOWN_SELECTOR = [
  '[data-radix-menu-content]',
  '[data-radix-dropdown-menu-content]',
  '[data-radix-popper-content-wrapper]',
  '[data-enterprise-account-portal]',
  '[role="menu"]',
].join(', ');

/** Clerk UserButton / OrganizationSwitcher popovers and shared popover chrome (portaled to `document.body`). */
const CLERK_PORTAL_SELECTOR = [
  '.cl-popoverBox',
  '.cl-userButtonPopover',
  '.cl-userButtonPopoverCard',
  '.cl-userButtonPopoverActions',
  '.cl-userButtonPopoverActionButton',
  '.cl-userButtonPopoverFooter',
  '.cl-organizationSwitcherPopover',
  '.cl-organizationSwitcherPopoverCard',
  '.cl-organizationSwitcherPopoverActions',
  '.cl-organizationSwitcherPopoverActionButton',
  '.cl-organizationSwitcherPopoverFooter',
  '.cl-organizationPreview',
].join(', ');

function isRadixDropdownPortal(target: HTMLElement | null): boolean {
  if (!target) return false;
  return Boolean(target.closest(RADIX_DROPDOWN_SELECTOR));
}

/** True when the node is inside a portaled menu (Clerk or Radix account/org switchers). */
export function isClerkPopoverOrPortal(target: HTMLElement | null): boolean {
  if (!target) return false;
  return Boolean(target.closest(CLERK_PORTAL_SELECTOR)) || isRadixDropdownPortal(target);
}

/** True when the pointer at (x, y) is over a portaled menu (sidebar hover-expand guard). */
export function isClerkPortalAtPoint(clientX: number, clientY: number): boolean {
  const elements = document.elementsFromPoint(clientX, clientY);
  return elements.some((el) => isClerkPopoverOrPortal(el instanceof HTMLElement ? el : null));
}

type SheetOutsideEvent = {
  target: EventTarget | null;
  preventDefault: () => void;
};

/**
 * `modal={false}` sheets: prevent dismiss when the outside interaction is Clerk UI or the
 * menu trigger (trigger sits outside SheetContent; without this, open + dismiss fire together).
 */
export function preventMobileSheetOutsideDismiss(event: SheetOutsideEvent): void {
  const target = event.target instanceof HTMLElement ? event.target : null;
  if (!target) return;

  if (isClerkPopoverOrPortal(target) || target.closest(RADIX_DROPDOWN_SELECTOR)) {
    event.preventDefault();
    return;
  }

  if (
    target.closest('[data-radix-dialog-trigger]') ||
    target.closest('[data-mobile-nav-trigger]')
  ) {
    event.preventDefault();
  }
}
